import { orgPeopleList } from '@repo/domains-organization';
import { axios } from '@repo/http';
import { useMutation, useQueryClient } from '@tanstack/react-query';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useInviteMember(param) {
    let { organization, page, perPage } = param;
    const queryClient = useQueryClient();
    const { queryKey } = orgPeopleList.peopleList({
        organization,
        page,
        perPage
    });
    return useMutation({
        mutationFn: (newMember)=>axios.post("/v2/organization/".concat(organization, "/invite"), newMember),
        onSettled: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
        }
    });
}
